import { useState } from 'react';

export const usePopupController = () => {
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const openDeletePopup = () => {
        setIsOpenPopup(true);
    };
    const closeDeletePopup = () => {
        setIsOpenPopup(false);
    };

    return {
        isOpenPopup,
        openDeletePopup,
        closeDeletePopup,
    };
};
